export class StudyReferenceNumSection {
    constructor(
        public sequenceNumSectionId: number,
        public sectionDetailId: number,
        public sectionLabel: string,
        public codeDesc: string,
    ) {}
}
